export default __webpack_public_path__ + "static/Montserrat-Light-VariableFont_wght-3068cdb43142f5625bafcb92563ecbfc.ttf";